import { render, staticRenderFns } from "./MainLanding.vue?vue&type=template&id=6f99907c&scoped=true&"
import script from "./MainLanding.vue?vue&type=script&lang=js&"
export * from "./MainLanding.vue?vue&type=script&lang=js&"
import style0 from "./MainLanding.vue?vue&type=style&index=0&id=6f99907c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f99907c",
  null
  
)

export default component.exports